import { createSelector } from 'reselect';

export const selectEarnStores = state => state.earnStores;
export const selectEarnStoresConfig = createSelector(selectEarnStores, ({ config }) => config);
export const selectEarnStoresIsLoading = createSelector(selectEarnStores, ({ isLoading }) => isLoading);
export const selectEarnStoresIsLoaded = createSelector(selectEarnStores, ({ isLoaded }) => isLoaded);
export const selectEarnStoresRecords = createSelector(selectEarnStores, ({ merchants }) => merchants);
